import { ShieldCheck } from 'lucide-react';
import { useIXVerifyAuth } from '../../contexts';
import { NotificationBell } from '../NotificationBell';
import SiteSelector from '../../../components/SiteSelector';
import { AppBar } from '../../../ui';

interface HeaderProps {
  onMenuClick?: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { user, supabaseUser, signOut } = useIXVerifyAuth();

  const displayName = user?.full_name || supabaseUser?.email || 'User';
  const displayEmail = supabaseUser?.email;

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <AppBar
      icon={<ShieldCheck className="h-4 w-4 text-white" />}
      toolName="IXVerify"
      titleHref="/ixverify/dashboard"
      onMenuClick={onMenuClick}
      right={
        supabaseUser && (
          <>
            {/* Site Selector */}
            <SiteSelector />

            {/* Notification Bell */}
            <NotificationBell />

            <div className="hidden sm:flex flex-col items-end">
              <span className="text-sm font-medium leading-tight text-white">
                {displayName}
              </span>
              {displayName !== displayEmail && (
                <span className="text-xs leading-tight text-white/70">
                  {displayEmail}
                </span>
              )}
            </div>
            <button
              type="button"
              onClick={handleSignOut}
              className="inline-flex min-h-[44px] items-center rounded-lg px-2.5 text-sm font-medium text-white/90 transition-colors duration-150 hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/60 sm:min-h-0 sm:py-1.5"
            >
              Sign Out
            </button>
          </>
        )
      }
    />
  );
}
